<template>
  <v-combobox
    v-model="selectedValue"
    :items="items"
    :hide-no-data="!search"
    :search-input.sync="search"
    small-chips
    outlined
    hide-details
    dense
    :label="labelText"
    :multiple="multipleItems"
    clearable
    @input="event => { $emit('input', event) }"
  >
  </v-combobox>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
      selectedValue: null,
      items: [],
      loading: false,
      search: null,
      callWhenUpdate: null,
      multipleItems: true,
      labelText: this.$t('message.available_classes')
    };
  },
  created() {
    if (this.hideLabel)
      this.labelText = "";
    else if (this.label)
      this.labelText = this.label;
    if (this.updateFunction)
      this.callWhenUpdate = this.updateFunction;
    if (this.single)
      this.multipleItems = false;
    Api()
      .get(
        "admins/academy/" + this.$store.state.managedAcademy + "/schedule"
      )
      .then(response => {
        if (response.data && response.data.list) {
          let classesSet = new Set();
          for (const c of response.data.list) {
            classesSet.add(c.name)
          }
          this.items = Array.from(classesSet);
        }
        this.loading = false;
      });
  },
  mounted(){
    this.selectedValue = this.value
  },
  props: {
    value: null,
    hideLabel: { default: false, type: Boolean },
    label: null,
    updateFunction: null,
    single: { default: false, type: Boolean },
    vm: null
  },
  watch: {
    value: {
      handler: function(newValue) {
        this.selectedValue = newValue;
        if (this.updateFunction) {
          this.callWhenUpdate(this.vm, newValue);
        }
      }
    }
  },
  methods: {
    async querySelections(v) {
      this.loading = true;
      if (this.affiliations.length == 0) {
        var r = await Api.get("academies/distinct/local_affiliations");
        if(r.data)
          this.affiliations = r.data.sort();
      }
      this.items = this.affiliations.filter(e => {
        return (e || "").toLowerCase().indexOf((v || "").toLowerCase()) > -1;
      });
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>